import Vue from 'vue'
// ViewUI
import ViewUI from 'view-design'

import './theme/viewui.less'

Vue.use(ViewUI, {
  transfer: true,
})
